import React, { Component } from "react";
import { If } from "react-extras";
import InfoTooltip from "./info";
import { classNames } from "react-extras";
import "../lib/stats/stats_widget.scss";

class HighlightBox extends Component {
  render() {
    const { title, value, infoText, scalableHeight } = this.props;

    return (
      <div className={classNames("highlight-box", scalableHeight && "scalable-height")}>
        <div className="highlight-box__inner">
          <div className="highlight-box__title redcircle-form-label">
            {title}
            <If condition={!!infoText}>
              <InfoTooltip helpText={infoText} />
            </If>
          </div>
          <h3 className="highlight-box__stat no-margin">{value}</h3>
        </div>
      </div>
    );
  }
}

export default HighlightBox;
